import * as React from 'react';

export default class ShareIcon extends React.Component {
  render() {
    return React.createElement('svg', {
      className: this.props.className || 'share-icon',
      width: this.props.width || '24px',
      height: this.props.height || '24px',
      viewBox: this.props.viewBox || '0 0 24 24',
      dangerouslySetInnerHTML: {
        __html:
          '<path d="M18.4,14.6c-1.5,0-2.9,0.9-3.5,2.2l-7.5-3.9c0.1-0.4,0.2-0.8,0.2-1.3c0-0.5-0.1-0.9-0.3-1.3l8-4  c0.7,0.9,1.8,1.4,3,1.4c2.1,0,3.9-1.7,3.9-3.9S20.6,0,18.4,0s-3.9,1.7-3.9,3.9c0,0.2,0,0.4,0.1,0.6L6.3,8.6C5.6,8,4.8,7.7,3.9,7.7  C1.7,7.7,0,9.4,0,11.6s1.7,3.9,3.9,3.9c0.9,0,1.8-0.4,2.5-0.9c0,0,0,0,0,0l8.2,4.3c0,0,0.1,0,0.1,0c0.2,1.9,1.8,3.4,3.8,3.4  c2.1,0,3.9-1.7,3.9-3.9S20.6,14.6,18.4,14.6z M18.4,2c1,0,1.9,0.8,1.9,1.9s-0.8,1.9-1.9,1.9s-1.9-0.8-1.9-1.9S17.4,2,18.4,2z   M3.9,13.4c-1,0-1.9-0.8-1.9-1.9c0-1,0.8-1.9,1.9-1.9s1.9,0.8,1.9,1.9C5.7,12.6,4.9,13.4,3.9,13.4z M18.4,20.3c-1,0-1.9-0.8-1.9-1.9  s0.8-1.9,1.9-1.9s1.9,0.8,1.9,1.9S19.5,20.3,18.4,20.3z"/>',
      },
    });
  }
}
